// @ts-nocheck
import LibSvg from "react-inlinesvg";

export type SVGProps = LibSvg.Props;

export const SVG = ({
  src,
  preProcessor = (code: string) => code,
  ...props
}: SVGProps) => {
  return <LibSvg src={src} preProcessor={preProcessor} {...props} />;
};
